import React from "react";
import { Input } from "reactstrap";
import "./form.css"

export const CustomInputNumeric = React.forwardRef((props, ref) => {
      const { className, ...rest } = props;
      return (
        <Input
          {...rest}
          ref={ref}
          className={`rounded-pill text-center input-color ${className}`}
        />
      );
    });